import RiddleBlock from './RiddleBlock';

export default RiddleBlock;
